<template>
  <div class="getinvoice">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class=""><router-link to="/home/invoice">发票列表</router-link></li>
          <li class="active"><a href="javascript:;">发票索取</a></li>
          <li class=""><router-link to="/home/managerinvoice">发票信息管理</router-link></li>
        </ul>
      </nav>
    </div>
    <div class="search">
      <el-input v-model="input" placeholder="输入订单编号" size="small"></el-input>
      <el-date-picker
        v-model="invoicetime"
        type="daterange"
        value-format="yyyy-MM-dd"
        align="right"
        unlink-panels
        size="small"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <span class="btn-srarch" @click="orderList">检索</span>
    </div>
    <p class="tb-title">
      全选: &nbsp;一共有{{total}}个订单可申请发票，已勾选{{selectCount}}个订单
    </p>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="detail"
      ref="getinvoicelist"
      @select = "selectMemoryFn"
      @select-all="selectMemoryFn">
      <el-table-column
        prop="id"
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        label="订单编号"
        width="200"
        align="left">
        <template slot-scope="scope">
          <a href="#">{{ scope.row.code }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="state"
        label="订单类型"
        align="center"
        >
        <template slot-scope="scope">
          {{ scope.row.orderType === 1 ? '遥感产品' : '遥感数据' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createdate"
        label="日期"
        width="240"
        align="center">
      </el-table-column>
      <el-table-column
        label="订单实付金额"
        align="center"
        >
      <template slot-scope="scope">
        {{ scope.row.amount }}
      </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        background
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <div class="c-sumbit">
      <span :class="submitbtn" @click="sumbit()">索取发票</span>
      待开票金额:<span class="price">￥{{ allprice }}</span>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :append-to-body='true' custom-class="invoicemanagerdialog">
      <invoiceItem :model="item" :orderIds="orderIds" :btndisable="disable" :Isprice="isprice" :allprice="allprice" @updatebtn = "updatebtn" @applyInvoiceSuccess="applyInvoiceCall" :btntext="btntext" @alertout="alertout"></invoiceItem>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
import invoiceItem from '@/components/invoice/invoiceItem.vue'
export default {
  name: 'Invoice',
  components: {
    'invoiceItem': invoiceItem
  },
  created () {
    this.orderList()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 0,
      selectCount: 0,
      input: '',
      invoicetime: '',
      checkstate: false,
      allprice: '0.00',
      submitbtn: 'btn-disable',
      dialogFormVisible: false,
      title: '发票信息',
      isprice: true,
      btntext: '索取发票',
      disable: 'disable',
      item: {},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      multipleSelection: [],
      tableData: [],
      orderIds: []
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.orderList()
    },
    selectMemoryFn (val, row) { // 设置分页记忆二位数组方法
      this.multipleSelection[this.currentPage - 1] = val
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.submitbtn = 'btn-able'
        this.allprice = '0.00'
        let selectIds = []
        this.multipleSelection.forEach((item) => {
          item.forEach(select => {
            selectIds.push(select.id)
            this.allprice = parseFloat(this.allprice) + parseFloat(select.amount)
          })
        })
        this.selectCount = selectIds.length
        this.orderIds = selectIds
        if (this.allprice === '0.00') {
          this.multipleSelection = []
          this.submitbtn = 'btn-disable'
        }
      } else {
        this.allprice = '0.00'
        this.multipleSelection = []
      }
    },
    selectMemoriedDataFn () { // 分页记忆自动选中方法
      let currentArr = this.multipleSelection[this.currentPage - 1] // 当前分页对应被选中数据
      if (currentArr && currentArr.length) { // 存在则继续执行
        let tempRowsIDs = this.tableData.map(L => L.id) // 当前分页被选中数据的id集合
        currentArr.forEach((item, index) => { // 遍历当前分页被选中数据
          if (tempRowsIDs.includes(item.id)) { // id匹配上，则选中
            this.$refs.getinvoicelist.toggleRowSelection(this.tableData[tempRowsIDs.indexOf(item.id)])
          }
        })
      }
    },
    orderList() {
      var startDate = ''
      var endDate = ''
      if (this.invoicetime) {
        startDate = this.invoicetime[0]
        endDate = this.invoicetime[1]
      }
      let queryParam = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        code: this.input,
        startDate: startDate,
        endDate: endDate
      }
      this.sapost('/dmc/account/invoiceOrders', queryParam, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.getinvoicelist.toggleRowSelection(row)
        })
      } else {
        this.$refs.getinvoicelist.clearSelection()
      }
    },
    applyInvoiceCall() {
      this.dialogFormVisible = false
      this.allprice = '0.00'
      this.orderList()
    },
    // 能够读取到队列中的具体某个数组直接用就好
    handleSelectionChange(val) {
      this.multipleSelection = val
      // 有选中则切换按钮颜色
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.submitbtn = 'btn-able'
        this.allprice = '0.00'
        this.multipleSelection.forEach((item) => {
          this.allprice = parseFloat(this.allprice) + parseFloat(item.amount)
        })
      } else {
        this.submitbtn = 'btn-disable'
        this.allprice = '0.00'
      }
    },
    sumbit () {
      if (this.submitbtn === 'btn-able') {
        this.dialogFormVisible = true
        let queryParam = {
          currentPage: 1,
          pageSize: 20
        }
        this.sapost('/dmc/account/invoice', queryParam, r => {
          let { retMsg, retCode, pager } = r.data
          if (retCode === '0') {
            let invoice = pager.list.find(item => item.is_default === 'y')
            if (invoice) {
              this.item = invoice
              this.updatebtn('tbn')
            } else {
              this.item = {}
              this.updatebtn('disable')
            }
          } else {
            if (retMsg === '用户未登录！') {
              eventBus.$emit('logout')
            }
            this.$message.warning(retMsg)
          }
        })
      }
    },
    alertout () {
      this.$alert('<p class="alert"><i class="el-icon-circle-check"></i>发票申请成功,将在3个工作日审批,审批通过即会寄出</p>', '提示', {
        dangerouslyUseHTMLString: true,
        customClass: 'invoicealert',
        callback: () => {
          console.log(111)
          this.dialogFormVisible = false
        }
      })
    },
    updatebtn (val) {
      this.disable = val
    }
  },
  watch: {
    tableData (oldVal, newVal) { // 监听数据变化，然后执行分页记忆自动选中回调
      this.$nextTick(() => {
        this.selectMemoriedDataFn()
      })
    }
  }
}
</script>

<style lang="less">
.getinvoice{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 550px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 65px;
          a{
            color:#b4b8bb;
          }
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a{
            color:#f97575;
          }
        }
      }
    }
  }
  .search{
    padding-left: 10px;
    margin-top: 15px;
    text-align: left;
    font-size: 12px;
    margin-bottom: 25px;
    .el-date-editor{
      width: 270px;
    }
    .el-select{
      width: 160px;
      .el-input__inner{
        width: 160px;
      }
    }
    .el-input{
      width: 180px;
      margin-right: 10px;
    }
    .el-date-editor {
      .el-icon-date{
        position: absolute;
        right: 1px;
        top: 2px;
      }
    }
    span,.el-date-editor,.el-select{
      margin-right: 10px;
    }
    span.btn-srarch{
      display: inline-block;
      padding: 0 15px;
      line-height: 32px;
      height: 32px;
      background-color: #f14242;
      margin-left: 100px;
      color: #fbdfdd;
      cursor: pointer;
    }
  }
  .tb-title{
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
    color: #606266;
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 14px;
    .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #f25252;
    }
  }
  .el-table,.tb-title{
    .el-checkbox__input.is-checked .el-checkbox__inner{
      background-color: #fff;
      border-color: #DCDFE6;
    }
    .el-checkbox__inner:hover,.el-checkbox__inner:focus{
      border-color: #f25252;
      outline: none;
    }
    .is-indeterminate .el-checkbox__inner{
      background-color: #f25252;
      border-color: #f25252;
    }
    .el-checkbox__inner::after{
      border-color: #f25252;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .c-sumbit{
    line-height: 45px;
    height: 45px;
    font-size: 12px;
    padding-bottom: 35px;
    span.btn-disable{
      display: inline-block;
      padding: 0 15px;
      line-height: 28px;
      height: 28px;
      background-color: #edf1f2;
      color: #bcbcbc;
      cursor: pointer;
    }
    span.btn-able{
      background-color: #f14242;
      color: #fbdfdd;
      display: inline-block;
      padding: 0 15px;
      line-height: 28px;
      height: 28px;
      cursor: pointer;
    }
    span.price{
      color: #f25252;
      font-size: 18px;
      font-weight: bold;
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/getInvoice.vue